import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";



export const getFollowup = (userId, token, followupId) => {
    return fetch(`${API}/followup/${userId}/${followupId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const saveFollowup=(userId,token,payload)=>{
    return fetch(`${API}/save/followup/${userId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const updateFollowup=(userId,token,followupId,payload)=>{
    return fetch(`${API}/update/followup/${userId}/${followupId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const deleteFollowup=(userId,token,payload)=>{
    return fetch(`${API}/delete/followups/${userId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getAllFollowup=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/followups/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const getFollowupCount=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/followups/count/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};




export const getFollowupUserCount=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/usercount/followups/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};




export const bulkReassign=(userId,token,payload)=>{
    return fetch(`${API}/bulk-reassign/followups/${userId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const downloadFollowUpAsExcel = (userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/download-followup/${userId}?${str}`,{
        method:'GET',
        headers:{
            Authorization:`Bearer ${token}`
        }
    }).then(response=>response.blob()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const followResponse=(userId,token,followupId,payload)=>{
    return fetch(`${API}/follow-response/${userId}/${followupId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const closeFollowUp = (userId, token, followupId) => {
    return fetch(`${API}/followup/close/${userId}/${followupId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
        },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};